import React from 'react'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

import View from './view.js'

export default function Logic(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  return (
    <View
      {...props}
      handleClose={() => setFlowTo(normalizePath(props.viewPath, '../../No'))}
    />
  )
}
